<template>
  <div class="col">
    <div v-bind:class="compClasses" v-on:click="reveal">
      <span class="agent-card__word">{{ card.word }}</span>
    </div>
  </div>
</template>

<script>
import { CardState, CardType, ViewModes } from '../../../../constants'
export default {
props: ['card', 'cardsRef','view'],
  data() {
        return {
        }
    },
    computed: {
      isRevealed: function(){
        return (this.card.state === CardState.REVEALED);
      },
      isMasterView: function(){
        return (this.view === ViewModes.MASTER);
      },
      showColor: function(){
        return (this.isMasterView || this.isRevealed);
      },
      compClasses: function(){
        return {
          "agent-card": true,
          "agent-card--master-view": this.isMasterView,
          "agent-card--revealed": this.isRevealed,
          "agent-card--blue": this.showColor & this.card.type === CardType.BLUE_AGENT,
          "agent-card--red": this.showColor & this.card.type === CardType.RED_AGENT,
          "agent-card--yellow": this.showColor & this.card.type === CardType.CIVILIST,
          "agent-card--black": this.showColor & this.card.type === CardType.ASSASSIN,
        }
      }
    },
    methods: {
      reveal: function(){
        this.$emit('revealCard');
      }
  },
}
</script>
<style lang="stylus">
@require './../../../../styles/index'
.agent-card
  padding 20px
  margin 5px
  mix-blend-mode normal
  box-sizing border-box
  border 2px solid transparent
  box-shadow 0px 4px 4px rgba(0, 0, 0, 0.5)
  font-style normal
  font-weight bold
  font-size 24px
  align-items center
  text-align center
  border-radius 20px
  color $color__font-color--default 
  background $color__background-card--default
  .dark-theme &
    color $color__font-color--dark-theme
    background $color__background--dark-theme
  &--revealed 
    & > span
      opacity 0
    &:hover > span
      opacity 1
    &.agent-card--blue
      background $color__blue--opacity-medium
    &.agent-card--red
      background $color__red--opacity-medium
    &.agent-card--yellow
      background $color__yellow--opacity-medium
    &.agent-card--black
      background $color__black
      color $color__grey
    &.agent-card--blue
    &.agent-card--red
    &.agent-card--yellow
      color $color__black
  &--master-view
    &.agent-card--blue
      border 2px solid $color__blue--opacity-high
      box-shadow 0px 4px 4px rgba(0, 0, 0, 0.5)
      color $color__blue
    &.agent-card--red
      border 2px solid $color__red--opacity-high
      box-shadow 0px 4px 4px rgba(0, 0, 0, 0.5)
      color $color__red
    &.agent-card--black
      background $color__black
      color $color__grey
  &--master-view&--revealed
    &.agent-card--blue
    &.agent-card--red
    &.agent-card--black
    &.agent-card--yellow
      color $color__font-color--default 
      border 2px solid transparent
      .dark-theme &
        color $color__background--dark-theme
</style>
